const Recommendations = { side: "left" };

export default {
	Recommendations,
};
